import { validateFileLimit, filterFiles } from "./fileValidation";
import { asyncFileAndFolderMultipleUpload } from "./asyncFileAndFolderMultipleUpload";

function bulkUploadMultipleFiles({
	matterID,
	basepath,
	directoryID,
	files,
	autoRename = false,
	callback = null,
	userIgnoredTheLimit = false,
}) {
	return function (dispatch) {
		// Validate file limit
		if (!validateFileLimit(files, dispatch)) {
			return;
		}

		// Filter bad files
		const filteredFiles = filterFiles(files);

		// Start async upload process
		asyncFileAndFolderMultipleUpload({
			matterID,
			basepath,
			directoryID,
			files: filteredFiles,
			autoRename,
			callback,
			dispatch,
			userIgnoredTheLimit,
		})
			.then(() => {
				callback && callback();
			})
			.catch((err) => {
				console.log(err);
			});
	};
}
export { bulkUploadMultipleFiles };
